<template>
    <DefaultTemplate>
        <div class="card rounded">
            <div class="card-content  pd-1">
                <h1 class="has-text-centered mg-b-1">กรุณาติดต่อเจ้าหน้าที่</h1>
                <div class="columns bordered rounded">
                    <div class="column is-5 has-background-primary">
                        <div class="has-text-white" :class="maxWidth > 768 ? 'pd-1':'pd-5'">
                            <div>
                                <p class="mg-b-3">ข้อมูลการติดต่อกลับเจ้าหน้าที่ ACE FORM</p>
                                <div class="is-flex mg-y-3">
                                    <figure class="is-rounded image has-background-white is-32x32 mg-r-4 is-flex ai-center js-center has-text-primary"><i  class="fas fa-user "></i></figure>
                                    <p><span>สรรเสริญ เมืองใจ (แฮม)</span></p>
                                </div>
                                <div class="is-flex mg-y-3">
                                    <figure  class=" is-rounded image has-background-white is-32x32 mg-r-4 is-flex ai-center js-center has-text-primary"><i class="fas fa-phone"></i></figure>
                                    <a href="tel:+66654699569" class="has-text-white">065-469-9569</a>
                                </div>
                                <div class="is-flex mg-y-3">
                                    <figure  class=" is-rounded image has-background-white is-32x32 mg-r-4 is-flex ai-center js-center has-text-primary"><i class="fas fa-envelope"></i></figure>
                                    <a href="mailto:sansern.ham@gmail.com" class="has-text-white">sansern.ham@gmail.com</a>
                                </div>
                                <div class="is-flex mg-y-3">
                                    <figure  class=" is-rounded image has-background-white is-32x32 mg-r-4 is-flex ai-center js-center has-text-primary"><i class="fab fa-line"></i></figure>
                                    <p>hamlikeher02</p>
                                </div>
                                  
                            </div>
                            <div class="has-text-centered mg-t-2">
                                <img src="@/assets/qr.png">
                            </div>
                        </div>
                    </div>
                    <div class="column is-7">
                        <div :class="maxWidth > 768 ? 'pd-1':'pd-5'">
                            <h4 class="mg-b-3 has-text-weight-bold">หรือ กรอกแบบฟอร์มเพื่อติดต่อเรา</h4>
                            <div class="columns flex-warp">
                                <div class="column is-6">
                                    <b-field label="ชื่อ">
                                        <b-input v-model="form.name"></b-input>
                                    </b-field>
                                </div>
                                <div class="column is-6">
                                    <b-field label="นามสกุล">
                                        <b-input v-model="form.surname"></b-input>
                                    </b-field>
                                </div>
                                <div class="column is-6">
                                    <b-field label="เบอร์โทรศัพท์">
                                        <b-input v-model="form.mobilephone"></b-input>
                                    </b-field>
                                </div>
                                <div class="column is-6">
                                    <b-field label="อีเมล">
                                        <b-input v-model="form.email"></b-input>
                                    </b-field>
                                </div>
                                <div class="column is-12">
                                    <b-field label="ข้อความ">
                                        <b-input type="textarea" v-model="form.text"></b-input>
                                    </b-field>
                                </div>
                                <div class="column has-text-centered">
                                    <button @click="sendMsg" type="submit" class="button submit" :style="styleObject">ส่งข้อความ</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import DefaultTemplate from '@/template/DefaultTemplate'
import { HTTP } from "@/service/axios.js";

export default {
    components:{
        DefaultTemplate
    },
    data(){
        return{
            form:{
                name:'',
                surname:'',
                mobilephone:'',
                email:'',
                text:''
            }
        }
    },
    methods:{
        sendMsg(){
            HTTP.post('contact',this.form).then(res=>{
                if(res.data.success){
                    this.$buefy.toast.open({ message: "เราได้รับข้อความของคุณแล้ว กรุณารอการติดต่อกลับจากเจ้าหน้าที่", type: "is-success" ,duration:10000});
                    this.onReset()
                }
            })
        },
        onReset(){
            this.form.name=''
            this.form.surname=''
            this.form.mobilephone=''
            this.form.email=''
            this.form.text=''
        }
    }
}
</script>

<style scoped>
    .waitBox{
        min-height: 450px;
        padding: 120px;
    }
</style>